import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";
import GraphMeasurement from "./graph-measurement.jsx";

const MeasurementModal = ({ isOpen, closeModal, measurementData, title }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-gray-900 opacity-50"></div>
      <div className="bg-white rounded-lg shadow-lg z-50 max-w-screen-lg w-full p-2 m-4">
        {measurementData.length > 0 ? (
          <GraphMeasurement measurementData={measurementData} title={title} />
        ) : (
          <div className="flex items-center justify-center text-gray-500 mt-4">
            <FontAwesomeIcon icon={faChartLine} className="text-3xl mr-2" />
            <span>There is no data to graph</span>
          </div>
        )}

        <div className="flex justify-center mt-4">
          <button
            className="bg-red-500 text-white px-4 py-2 rounded"
            onClick={closeModal}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MeasurementModal;
